import { createEvent, createStore } from "effector"
import { useStore } from "effector-react"

const usePopout = () => {
    return {
        data: useStore($popoutStore)
    }
}

export type TPopout =
    | 'training'
    | 'admission'

const setPopout = createEvent<TPopout | null>()

export const $popoutStore = createStore<TPopout | null>(null)
    .on(setPopout, (_, modal) => modal)

export const selectors = {
    usePopout,
}

export const events = {
    setPopout
}
